// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alegreya:ital,wght@0,400;0,600;1,400&family=Open+Sans:ital,wght@0,300;0,400;0,600;0,800;1,300&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto+Mono:wght@500&family=Roboto:ital,wght@1,300&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* colors */

/* reset.css */
/* Reset margins and paddings */
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 1rem;
  text-decoration: initial;
  color: inherit;
  font: inherit;
  vertical-align: baseline;
}

/* Normalize HTML5 display */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

/* Global CSS Reset */
html,
body {
  width: 100%;
  margin: 0;
  padding: 0;
  line-height: 1;
  overflow: hidden;
  /* Disable scrolling on the body */
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

/* Additional resets for more consistency */
a {
  text-decoration: none;
  color: inherit;
}

button,
input,
textarea {
  font-family: inherit;
  font-size: inherit;
  background: none;
  border: none;
  outline: none;
  appearance: none;
}

h1,
h2 {
  font-family: "Open Sans", sans-serif;
  font-weight: bold;
  letter-spacing: 3px;
}

h3,
h4 {
  font-family: "Open Sans", sans-serif;
  font-weight: bold;
  font-size: 16px;
}

p,
span,
div,
label {
  font-family: "Alegreya", serif;
  letter-spacing: 0.5px;
  line-height: 1.25;
  font-size: 14px;
}

span {
  display: inline-block;
}

.pointer {
  cursor: pointer;
}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
}

.small {
  font-size: 0.8em !important;
}

.error {
  color: #ad535d;
}

.tx-left {
  text-align: left;
}

.tx-right {
  text-align: right;
}

a {
  text-decoration: none !important;
}

/* Hide the default scrollbar */
.scroll-container {
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  /* Smooth scrolling on iOS */
}

.scroll-container:not(:has(*))::-webkit-scrollbar {
  display: none;
  /* Hide scrollbar track */
}

/* Alternatively, check if content overflows */
.scroll-container:not(:has(:first-child:last-child))::-webkit-scrollbar {
  display: none;
  /* No scrollbar if there's only one child or no children */
}

.scroll-container::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: transparent;
}

.hide.scroll-container::-webkit-scrollbar {
  width: 0;
  height: 0;
}

/* Style the scrollbar track */
.scroll-container::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #ffffff;
}

/* Style the scrollbar thumb */
.scroll-container::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #888;
}

/* Style the scrollbar thumb on hover */
.scroll-container::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}

.underline {
  text-decoration: underline !important;
}

hr {
  opacity: 1;
  margin: 15px 0;
  z-index: 0;
  border-color: #f1f3f4;
}

.hidden {
  display: none;
}

.blue {
  color: #333 !important;
}

.black {
  color: #000000 !important;
}

.flex {
  display: flex;
}

.grid {
  display: grid;
}

.flex-column {
  flex-direction: column;
}

.flex-one {
  flex: 1 1;
}

.flex-two {
  flex: 2 1;
}

.flex-three {
  flex: 3 1;
}

.wrap {
  flex-wrap: wrap;
}

.w-0 {
  width: 0%;
}

.w-25 {
  width: 25%;
}

.w-50 {
  width: 50%;
}

.w-75 {
  width: 75%;
}

.w-33 {
  width: 32.33%;
  margin-left: 0;
  margin-right: 1.5%;
}
.w-33:nth-child(3n) {
  margin-right: 0;
  /* Remove margin-right for every 3rd item */
}
.w-33:first-child {
  margin-left: 0;
}
.w-33:last-child {
  margin-right: 0;
}

.items-center {
  align-items: center;
}

.items-start {
  align-items: flex-start;
}

.items-end {
  align-items: flex-end;
}

.italic {
  font-style: italic;
}

.justify-center {
  justify-content: center;
}

.justify-start {
  justify-content: flex-start;
}

.justify-end {
  justify-content: flex-end;
}

.justify-space-between {
  justify-content: space-between;
}

.justify-space-evenly {
  justify-content: space-evenly;
}

.justify-space-around {
  justify-content: space-around;
}

.flex-wrap {
  flex-wrap: wrap;
}

.align-center {
  align-items: center;
}

.align-start {
  align-items: flex-start;
}

.align-self-end {
  align-self: flex-end;
}

.align-self-start {
  align-self: flex-start;
}

.absolute {
  position: absolute;
}

.w-100 {
  width: 100% !important;
}

.w-90 {
  width: 90% !important;
}

.w-80 {
  width: 80% !important;
}

.max-w-80 {
  max-width: 80% !important;
}

.w-30 {
  width: 30% !important;
}

.w-70 {
  width: 70% !important;
}

.h-100 {
  height: 100% !important;
}

.h-90 {
  height: 90% !important;
}

.h-95 {
  height: 95% !important;
}

.overflow-hidden {
  overflow: hidden;
}

.input-spacing {
  margin: 10px 30px;
}

.field-style {
  margin: 15px 0;
}

.b {
  font-weight: bold;
}

.mt-sm {
  margin-top: 5px;
}

.mt-md {
  margin-top: 15px;
}

.mt-lg {
  margin-top: 35px;
}

.mb-sm {
  margin-bottom: 5px;
}

.mb-md {
  margin-bottom: 15px;
}

.mb-lg {
  margin-bottom: 35px;
}

.mr-sm {
  margin-right: 5px;
}

.mr-md {
  margin-right: 15px;
}

.mr-lg {
  margin-right: 35px;
}

.ml-sm {
  margin-left: 5px;
}

.ml-md {
  margin-left: 15px;
}

.ml-lg {
  margin-left: 35px;
}

.pa-sm {
  padding: 5px;
}

.pa-md {
  padding: 15px;
}

.pl-md {
  padding-left: 15px;
}

.pl-lg {
  padding-left: 35px;
}

.pb-sm {
  padding-bottom: 5px;
}

.pb-md {
  padding-bottom: 15px;
}

.pb-lg {
  padding-bottom: 35px;
}

.pt-md {
  padding-top: 15px;
}

.pt-lg {
  padding-top: 35px;
}

.pr-sm {
  padding-right: 5px;
}

.pl-sm {
  padding-left: 5px;
}

.pr-md {
  padding-right: 15px;
}

.pr-lg {
  padding-right: 35px;
}

.m-center {
  margin: 0 auto;
}

.rbc-overlay span,
.rbc-overlay div {
  font-family: "Roboto Mono", monospace;
}

.ace_editor {
  font-family: monospace;
}

.ace_editor div {
  font-family: monospace;
}
.ace_editor div span {
  font-family: monospace;
}

.editor .rdw-editor-main {
  background: #ffffff;
}

input {
  font-family: "Open Sans", sans-serif;
  margin: 0;
  padding: 0;
  border: none;
  outline: none;
  font-size: 1rem;
}

.react-loading-skeleton {
  width: 100%;
}

.pac-container {
  z-index: 999999999;
}

.tooltip {
  z-index: 999999999;
}

.MuiDataGrid-container--top [role=row] {
  background: transparent !important;
}

.MuiDataGrid-selectedRowCount {
  visibility: hidden !important;
}

.MuiPopper-root {
  z-index: 90000000;
}

.MuiDataGrid-panel {
  z-index: 90000000 !important;
}

.MuiPopover-root {
  z-index: 90000000 !important;
}

.MuiPaper-root {
  z-index: 90000000 !important;
}

.rc-time-picker-panel {
  z-index: 9999999;
}

.arrow {
  pointer-events: none;
}

.arrow__path {
  stroke: #fff;
  fill: transparent;
  stroke-dasharray: 4 2;
}

.arrow__head line {
  stroke: #fff;
  stroke-width: 1px;
  display: none;
}

.tox-tinymce {
  border-radius: 0 !important;
}

.fc .fc-scroller-harness {
  z-index: 1;
}

.ReactModal__Overlay {
  z-index: 99999999 !important;
}

.DateRangePicker_picker {
  z-index: 2;
}

.tox-tinymce {
  overflow: visible !important;
}

.Toastify__toast-container {
  z-index: 999999999;
}

.tox .tox-collection--list .tox-collection__item--active:not(.tox-collection__item--state-disabled) {
  background-color: #1181C1 !important;
}`, "",{"version":3,"sources":["webpack://./src/globalStyles.scss"],"names":[],"mappings":"AAGA,WAAA;;AAsEA,cAAA;AAEA,+BAAA;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiFE,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,wBAAA;EACA,cAAA;EACA,aAAA;EACA,wBAAA;AArCF;;AAwCA,4BAAA;AACA;;;;;;;;;;;EAWE,cAAA;AArCF;;AAwCA,qBAAA;AACA;;EAEE,WAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;EACA,kCAAA;AArCF;;AAwCA;;;EAGE,sBAAA;AArCF;;AAwCA;;EAEE,gBAAA;AArCF;;AAwCA;;EAEE,YAAA;AArCF;;AAwCA;;;;EAIE,WAAA;EACA,aAAA;AArCF;;AAwCA;EACE,yBAAA;EACA,iBAAA;AArCF;;AAwCA,2CAAA;AACA;EACE,qBAAA;EACA,cAAA;AArCF;;AAwCA;;;EAGE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EAGA,gBAAA;AArCF;;AAwCA;;EAEE,oCA9OS;EA+OT,iBAAA;EACA,mBA5Oe;AAuMjB;;AAwCA;;EAEE,oCArPS;EAsPT,iBAAA;EACA,eAAA;AArCF;;AAwCA;;;;EAIE,8BA7PS;EA8PT,qBAAA;EACA,iBAAA;EACA,eAAA;AArCF;;AAwCA;EACE,qBAAA;AArCF;;AAwCA;EACE,eAAA;AArCF;;AAwCA;EACE,kBAAA;AArCF;;AAwCA;EACE,kBAAA;AArCF;;AAwCA;EACE,2BAAA;AArCF;;AAwCA;EACE,cAjRI;AA4ON;;AAwCA;EACE,gBAAA;AArCF;;AAwCA;EACE,iBAAA;AArCF;;AAwCA;EACE,gCAAA;AArCF;;AAwCA,+BAAA;AACA;EACE,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,4BAAA;AArCF;;AAwCA;EACE,aAAA;EACA,yBAAA;AArCF;;AAwCA,8CAAA;AACA;EACE,aAAA;EACA,0DAAA;AArCF;;AAyCA;EACE,UAAA;EACA,WAAA;EACA,6BAAA;AAtCF;;AAyCA;EACE,QAAA;EACA,SAAA;AAtCF;;AAyCA,8BAAA;AACA;EACE,mBAAA;EACA,yBAzTM;AAmRR;;AAyCA,8BAAA;AACA;EACE,mBAAA;EACA,sBAAA;AAtCF;;AAyCA,uCAAA;AACA;EACE,sBAAA;AAtCF;;AAyCA;EACE,qCAAA;AAtCF;;AAyCA;EACE,UAAA;EACA,cAAA;EACA,UAAA;EACA,qBA7UW;AAuSb;;AA6DA;EACE,aAAA;AA1DF;;AA6DA;EACE,sBAAA;AA1DF;;AA6DA;EACE,yBAAA;AA1DF;;AA6DA;EACE,aAAA;AA1DF;;AA6DA;EACE,aAAA;AA1DF;;AA6DA;EACE,sBAAA;AA1DF;;AA6DA;EACE,SAAA;AA1DF;;AA6DA;EACE,SAAA;AA1DF;;AA6DA;EACE,SAAA;AA1DF;;AA6DA;EACE,eAAA;AA1DF;;AA6DA;EACE,SAAA;AA1DF;;AA6DA;EACE,UAAA;AA1DF;;AA6DA;EACE,UAAA;AA1DF;;AA6DA;EACE,UAAA;AA1DF;;AA6DA;EACE,aAAA;EACA,cAAA;EACA,kBAAA;AA1DF;AA4DE;EACE,eAAA;EACA,2CAAA;AA1DJ;AA6DE;EACE,cAAA;AA3DJ;AA8DE;EACE,eAAA;AA5DJ;;AAiEA;EACE,mBAAA;AA9DF;;AAiEA;EACE,uBAAA;AA9DF;;AAiEA;EACE,qBAAA;AA9DF;;AAiEA;EACE,kBAAA;AA9DF;;AAiEA;EACE,uBAAA;AA9DF;;AAiEA;EACE,2BAAA;AA9DF;;AAiEA;EACE,yBAAA;AA9DF;;AAiEA;EACE,8BAAA;AA9DF;;AAiEA;EACE,6BAAA;AA9DF;;AAiEA;EACE,6BAAA;AA9DF;;AAiEA;EACE,eAAA;AA9DF;;AAiEA;EACE,mBAAA;AA9DF;;AAiEA;EACE,uBAAA;AA9DF;;AAiEA;EACE,oBAAA;AA9DF;;AAiEA;EACE,sBAAA;AA9DF;;AAiEA;EACE,kBAAA;AA9DF;;AAiEA;EACE,sBAAA;AA9DF;;AAiEA;EACE,qBAAA;AA9DF;;AAiEA;EACE,qBAAA;AA9DF;;AAiEA;EACE,yBAAA;AA9DF;;AAiEA;EACE,qBAAA;AA9DF;;AAiEA;EACE,qBAAA;AA9DF;;AAiEA;EACE,uBAAA;AA9DF;;AAiEA;EACE,sBAAA;AA9DF;;AAiEA;EACE,sBAAA;AA9DF;;AAiEA;EACE,gBAAA;AA9DF;;AAiEA;EACE,iBAAA;AA9DF;;AAiEA;EACE,cAAA;AA9DF;;AAiEA;EACE,iBAAA;AA9DF;;AAiEA;EACE,eAAA;AA9DF;;AAiEA;EACE,gBAAA;AA9DF;;AAiEA;EACE,gBAAA;AA9DF;;AAiEA;EACE,kBAAA;AA9DF;;AAiEA;EACE,mBAAA;AA9DF;;AAiEA;EACE,mBAAA;AA9DF;;AAiEA;EACE,iBAAA;AA9DF;;AAiEA;EACE,kBAAA;AA9DF;;AAiEA;EACE,kBAAA;AA9DF;;AAiEA;EACE,gBAAA;AA9DF;;AAiEA;EACE,iBAAA;AA9DF;;AAiEA;EACE,iBAAA;AA9DF;;AAiEA;EACE,YAAA;AA9DF;;AAiEA;EACE,aAAA;AA9DF;;AAiEA;EACE,kBAAA;AA9DF;;AAiEA;EACE,kBAAA;AA9DF;;AAiEA;EACE,mBAAA;AA9DF;;AAiEA;EACE,oBAAA;AA9DF;;AAiEA;EACE,oBAAA;AA9DF;;AAiEA;EACE,iBAAA;AA9DF;;AAiEA;EACE,iBAAA;AA9DF;;AAiEA;EACE,kBAAA;AA9DF;;AAiEA;EACE,iBAAA;AA9DF;;AAiEA;EACE,mBAAA;AA9DF;;AAiEA;EACE,mBAAA;AA9DF;;AAiEA;EACE,cAAA;AA9DF;;AAmEE;;EAEE,qCAjqBK;AAimBT;;AAoEA;EACE,sBAAA;AAjEF;;AAqEE;EACE,sBAAA;AAlEJ;AAoEI;EACE,sBAAA;AAlEN;;AAwEE;EACE,mBAtqBI;AAimBR;;AAyEA;EACE,oCA5rBS;EA6rBT,SAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;AAtEF;;AAyEA;EACE,WAAA;AAtEF;;AAyEA;EACE,kBAAA;AAtEF;;AAyEA;EACE,kBAAA;AAtEF;;AAyEA;EACE,kCAAA;AAtEF;;AAyEA;EACE,6BAAA;AAtEF;;AAyEA;EACE,iBAAA;AAtEF;;AAyEA;EACE,4BAAA;AAtEF;;AAyEA;EACE,4BAAA;AAtEF;;AAyEA;EACE,4BAAA;AAtEF;;AAyEA;EACE,gBAAA;AAtEF;;AAyEA;EACE,oBAAA;AAtEF;;AAyEA;EACE,YAAA;EACA,iBAAA;EACA,qBAAA;AAtEF;;AAyEA;EACE,YAAA;EACA,iBAAA;EACA,aAAA;AAtEF;;AAyEA;EACE,2BAAA;AAtEF;;AAyEA;EACE,UAAA;AAtEF;;AAyEA;EACE,4BAAA;AAtEF;;AA0EA;EACE,UAAA;AAvEF;;AA0EA;EACE,4BAAA;AAvEF;;AA0EA;EACE,kBAAA;AAvEF;;AA0EA;EACE,oCAAA;AAvEF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Alegreya:ital,wght@0,400;0,600;1,400&family=Open+Sans:ital,wght@0,300;0,400;0,600;0,800;1,300&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Roboto+Mono:wght@500&family=Roboto:ital,wght@1,300&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\n/* colors */\n\n$openSans: 'Open Sans', sans-serif;\n$alegreya: 'Alegreya', serif;\n$roboto: 'Roboto Mono', monospace;\n$poppins: 'Poppins', sans-serif;\n$letter-spacing: 3px;\n$green: #00b894;\n$save: #008000;\n// $blue: #2274a5;\n$red: #ad535d;\n$light-black: #3333337b;\n$lighter-gray: #f7f7f98a;\n$light-blue: #5290e248;\n\n// home page colors\n$blue: #333;\n$yellow: #CCA300;\n$black: #000000;\n$white: #ffffff;\n$dark-gray: #f7f7f9;\n$light-gray: #f1f3f4;\n$gost-white: #dadada;\n$muted-blue: #1e2f3c6f;\n$background: #121212;\n$background-secondary: #333;\n$background-overlay: #0000007a;\n$primary: #1181C1;\n$secondary: #4fc3f7;\n$secondary-light: $primary;\n$disabled-dark: #423b52;\n$task: #008F72;\n$calendar: $primary;\n\n:export {\n  openSans: $openSans;\n  alegreya: $alegreya;\n  roboto: $roboto;\n  poppins: $poppins;\n  letterSpacing: $letter-spacing;\n  red: $red;\n  green: $green;\n  yellow: $yellow;\n  white: $white;\n  blue: $primary;\n  lightBlack: $light-black;\n  lightGray: $light-gray;\n  lighterGray: $lighter-gray;\n  darkGray: $dark-gray;\n  lightBlue: $light-blue;\n  gostWhite: $gost-white;\n  save: $save;\n\n  // home page colors\n  black: $black;\n  white: $white;\n\n  // dark mode colors\n  background: $background;\n  primary: $primary;\n  secondary: $secondary;\n  secondaryLight: $secondary-light;\n  backgroundSecondary: $background-secondary;\n  disabledDark: $disabled-dark;\n  backgroundOverlay: $background-overlay;\n  mutedBlue: $muted-blue;\n  task: $task;\n  calendar: $calendar;\n}\n\n/* reset.css */\n\n/* Reset margins and paddings */\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 1rem;\n  text-decoration: initial;\n  color: inherit;\n  font: inherit;\n  vertical-align: baseline;\n}\n\n/* Normalize HTML5 display */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block;\n}\n\n/* Global CSS Reset */\nhtml,\nbody {\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  line-height: 1;\n  overflow: hidden;\n  /* Disable scrolling on the body */\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nol,\nul {\n  list-style: none;\n}\n\nblockquote,\nq {\n  quotes: none;\n}\n\nblockquote:before,\nblockquote:after,\nq:before,\nq:after {\n  content: '';\n  content: none;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n/* Additional resets for more consistency */\na {\n  text-decoration: none;\n  color: inherit;\n}\n\nbutton,\ninput,\ntextarea {\n  font-family: inherit;\n  font-size: inherit;\n  background: none;\n  border: none;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\nh1,\nh2 {\n  font-family: $openSans;\n  font-weight: bold;\n  letter-spacing: $letter-spacing;\n}\n\nh3,\nh4 {\n  font-family: $openSans;\n  font-weight: bold;\n  font-size: 16px;\n}\n\np,\nspan,\ndiv,\nlabel {\n  font-family: $alegreya;\n  letter-spacing: 0.5px;\n  line-height: 1.25;\n  font-size: 14px;\n}\n\nspan {\n  display: inline-block;\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.relative {\n  position: relative;\n}\n\n.absolute {\n  position: absolute;\n}\n\n.small {\n  font-size: 0.8em !important;\n}\n\n.error {\n  color: $red;\n}\n\n.tx-left {\n  text-align: left;\n}\n\n.tx-right {\n  text-align: right;\n}\n\na {\n  text-decoration: none !important;\n}\n\n/* Hide the default scrollbar */\n.scroll-container {\n  overflow-y: auto;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch;\n  /* Smooth scrolling on iOS */\n}\n\n.scroll-container:not(:has(*))::-webkit-scrollbar {\n  display: none;\n  /* Hide scrollbar track */\n}\n\n/* Alternatively, check if content overflows */\n.scroll-container:not(:has(:first-child:last-child))::-webkit-scrollbar {\n  display: none;\n  /* No scrollbar if there's only one child or no children */\n}\n\n\n.scroll-container::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n  background-color: transparent;\n}\n\n.hide.scroll-container::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n/* Style the scrollbar track */\n.scroll-container::-webkit-scrollbar-track {\n  border-radius: 10px;\n  background-color: $white;\n}\n\n/* Style the scrollbar thumb */\n.scroll-container::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  background-color: #888;\n}\n\n/* Style the scrollbar thumb on hover */\n.scroll-container::-webkit-scrollbar-thumb:hover {\n  background-color: #555;\n}\n\n.underline {\n  text-decoration: underline !important;\n}\n\nhr {\n  opacity: 1;\n  margin: 15px 0;\n  z-index: 0;\n  border-color: $light-gray;\n}\n\n@mixin hoverLine($color) {\n  &::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    right: 50%;\n    height: 2px;\n    background-color: $color;\n    transition: all 0.3s ease-in-out;\n    margin-bottom: -5px;\n  }\n\n  &:hover::after,\n  &.active::after {\n    left: 0;\n    right: 0;\n  }\n}\n\n.hidden {\n  display: none;\n}\n\n.blue {\n  color: $blue !important;\n}\n\n.black {\n  color: $black !important;\n}\n\n.flex {\n  display: flex;\n}\n\n.grid {\n  display: grid;\n}\n\n.flex-column {\n  flex-direction: column;\n}\n\n.flex-one {\n  flex: 1;\n}\n\n.flex-two {\n  flex: 2;\n}\n\n.flex-three {\n  flex: 3;\n}\n\n.wrap {\n  flex-wrap: wrap;\n}\n\n.w-0 {\n  width: 0%;\n}\n\n.w-25 {\n  width: 25%;\n}\n\n.w-50 {\n  width: 50%;\n}\n\n.w-75 {\n  width: 75%;\n}\n\n.w-33 {\n  width: 32.33%;\n  margin-left: 0;\n  margin-right: 1.5%;\n\n  &:nth-child(3n) {\n    margin-right: 0;\n    /* Remove margin-right for every 3rd item */\n  }\n\n  &:first-child {\n    margin-left: 0;\n  }\n\n  &:last-child {\n    margin-right: 0;\n  }\n}\n\n\n.items-center {\n  align-items: center;\n}\n\n.items-start {\n  align-items: flex-start;\n}\n\n.items-end {\n  align-items: flex-end;\n}\n\n.italic {\n  font-style: italic;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.justify-start {\n  justify-content: flex-start;\n}\n\n.justify-end {\n  justify-content: flex-end;\n}\n\n.justify-space-between {\n  justify-content: space-between;\n}\n\n.justify-space-evenly {\n  justify-content: space-evenly;\n}\n\n.justify-space-around {\n  justify-content: space-around;\n}\n\n.flex-wrap {\n  flex-wrap: wrap;\n}\n\n.align-center {\n  align-items: center;\n}\n\n.align-start {\n  align-items: flex-start;\n}\n\n.align-self-end {\n  align-self: flex-end;\n}\n\n.align-self-start {\n  align-self: flex-start;\n}\n\n.absolute {\n  position: absolute;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-90 {\n  width: 90% !important;\n}\n\n.w-80 {\n  width: 80% !important;\n}\n\n.max-w-80 {\n  max-width: 80% !important;\n}\n\n.w-30 {\n  width: 30% !important;\n}\n\n.w-70 {\n  width: 70% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-90 {\n  height: 90% !important;\n}\n\n.h-95 {\n  height: 95% !important;\n}\n\n.overflow-hidden {\n  overflow: hidden;\n}\n\n.input-spacing {\n  margin: 10px 30px;\n}\n\n.field-style {\n  margin: 15px 0;\n}\n\n.b {\n  font-weight: bold;\n}\n\n.mt-sm {\n  margin-top: 5px;\n}\n\n.mt-md {\n  margin-top: 15px;\n}\n\n.mt-lg {\n  margin-top: 35px;\n}\n\n.mb-sm {\n  margin-bottom: 5px;\n}\n\n.mb-md {\n  margin-bottom: 15px;\n}\n\n.mb-lg {\n  margin-bottom: 35px;\n}\n\n.mr-sm {\n  margin-right: 5px;\n}\n\n.mr-md {\n  margin-right: 15px;\n}\n\n.mr-lg {\n  margin-right: 35px;\n}\n\n.ml-sm {\n  margin-left: 5px;\n}\n\n.ml-md {\n  margin-left: 15px;\n}\n\n.ml-lg {\n  margin-left: 35px;\n}\n\n.pa-sm {\n  padding: 5px;\n}\n\n.pa-md {\n  padding: 15px;\n}\n\n.pl-md {\n  padding-left: 15px;\n}\n\n.pl-lg {\n  padding-left: 35px;\n}\n\n.pb-sm {\n  padding-bottom: 5px;\n}\n\n.pb-md {\n  padding-bottom: 15px;\n}\n\n.pb-lg {\n  padding-bottom: 35px;\n}\n\n.pt-md {\n  padding-top: 15px;\n}\n\n.pt-lg {\n  padding-top: 35px;\n}\n\n.pr-sm {\n  padding-right: 5px;\n}\n\n.pl-sm {\n  padding-left: 5px;\n}\n\n.pr-md {\n  padding-right: 15px;\n}\n\n.pr-lg {\n  padding-right: 35px;\n}\n\n.m-center {\n  margin: 0 auto;\n}\n\n.rbc-overlay {\n\n  span,\n  div {\n    font-family: $roboto;\n  }\n}\n\n.ace_editor {\n  font-family: monospace;\n}\n\n.ace_editor {\n  div {\n    font-family: monospace;\n\n    span {\n      font-family: monospace;\n    }\n  }\n}\n\n.editor {\n  .rdw-editor-main {\n    background: $white;\n  }\n}\n\ninput {\n  font-family: $openSans;\n  margin: 0;\n  padding: 0;\n  border: none;\n  outline: none;\n  font-size: 1rem;\n}\n\n.react-loading-skeleton {\n  width: 100%;\n}\n\n.pac-container {\n  z-index: 999999999;\n}\n\n.tooltip {\n  z-index: 999999999;\n}\n\n.MuiDataGrid-container--top [role=row] {\n  background: transparent !important;\n}\n\n.MuiDataGrid-selectedRowCount {\n  visibility: hidden !important;\n}\n\n.MuiPopper-root {\n  z-index: 90000000;\n}\n\n.MuiDataGrid-panel {\n  z-index: 90000000 !important;\n}\n\n.MuiPopover-root {\n  z-index: 90000000 !important;\n}\n\n.MuiPaper-root {\n  z-index: 90000000 !important;\n}\n\n.rc-time-picker-panel {\n  z-index: 9999999;\n}\n\n.arrow {\n  pointer-events: none;\n}\n\n.arrow__path {\n  stroke: #fff;\n  fill: transparent;\n  stroke-dasharray: 4 2;\n}\n\n.arrow__head line {\n  stroke: #fff;\n  stroke-width: 1px;\n  display: none;\n}\n\n.tox-tinymce {\n  border-radius: 0 !important;\n}\n\n.fc .fc-scroller-harness {\n  z-index: 1;\n}\n\n.ReactModal__Overlay {\n  z-index: 99999999 !important;\n}\n\n\n.DateRangePicker_picker {\n  z-index: 2;\n}\n\n.tox-tinymce {\n  overflow: visible !important;\n}\n\n.Toastify__toast-container {\n  z-index: 999999999;\n}\n\n.tox .tox-collection--list .tox-collection__item--active:not(.tox-collection__item--state-disabled) {\n  background-color: $primary !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"openSans": `"Open Sans", sans-serif`,
	"alegreya": `"Alegreya", serif`,
	"roboto": `"Roboto Mono", monospace`,
	"poppins": `"Poppins", sans-serif`,
	"letterSpacing": `3px`,
	"red": `#ad535d`,
	"green": `#00b894`,
	"yellow": `#CCA300`,
	"white": `#ffffff`,
	"blue": `#1181C1`,
	"lightBlack": `rgba(51, 51, 51, 0.4823529412)`,
	"lightGray": `#f1f3f4`,
	"lighterGray": `rgba(247, 247, 249, 0.5411764706)`,
	"darkGray": `#f7f7f9`,
	"lightBlue": `rgba(82, 144, 226, 0.2823529412)`,
	"gostWhite": `#dadada`,
	"save": `#008000`,
	"black": `#000000`,
	"background": `#121212`,
	"primary": `#1181C1`,
	"secondary": `#4fc3f7`,
	"secondaryLight": `#1181C1`,
	"backgroundSecondary": `#333`,
	"disabledDark": `#423b52`,
	"backgroundOverlay": `rgba(0, 0, 0, 0.4784313725)`,
	"mutedBlue": `rgba(30, 47, 60, 0.4352941176)`,
	"task": `#008F72`,
	"calendar": `#1181C1`
};
export default ___CSS_LOADER_EXPORT___;
